import { useState, useEffect } from 'react';
import axios from 'axios';
import automobyApi from '../Api';

export const useBank = (carId) => {
   const api = "" 
   //useEffect(() => {
   // fetchBanks(carId, typeId);
   //}, []);

   const fetchBanks = () => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        car_id: carId,
      };
  
      automobyApi
        .post("/bank/list", requestData)
        .then(response => {
          resolve(response.data.banks);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

 
  
  const addBankContainer = (newBank) => {
    return new Promise((resolve, reject) => { 
  
      automobyApi
        .post("/bank/add", newBank)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };



  const removeBank = (bankId) => {
    return new Promise((resolve, reject) => {
      const requestData = {
        bank_id: bankId
      };
  
      automobyApi
        .post("/bank/remove", requestData)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          console.error(error);
          reject(error);
        });
    });
  };

  const fetchByContainerId = (containerId) => {
    return new Promise((resolve, reject) => {
      const requestData = { 
        container_id: containerId,
      };
  
      automobyApi
        .post("/bank/container/list", requestData)
        .then(response => {
          resolve(response.data.banks);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

 
   
  const bankService = {
    fetchBanks: fetchBanks,
    addBankContainer: addBankContainer,
 
    removeBank: removeBank, 
    fetchByContainerId:fetchByContainerId,
 
   };

  return { bankService };
 
}